// extracted by mini-css-extract-plugin
export var askAiIcon = "_m8-9";
export var container = "_m8-0";
export var groupSeparator = "_m8-a";
export var highlight = "_m8-4";
export var resultIcon = "_m8-5";
export var resultItem = "_m8-7";
export var resultSubtitle = "_m8-3";
export var resultTitle = "_m8-2";
export var resultsList = "_m8-1";
export var searchGroup = "_m8-6";
export var selected = "_m8-8";